module.exports = __webpack_public_path__ + "img/sunny.9b875f3e.png";